import {reduxForm, Field} from 'redux-form'
import styles from './CheckoutForm.css'
import SwitchField from 'components/Fields/ReduxForm/SwitchField'

class CheckoutForm extends React.Component {
  static FORM_NAME = 'checkout'

  render () {
    return (<form onSubmit={this.props.handleSubmit}>
      <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <div className='row'>
            <div className='col-sm-12'>
              <div className={styles.header}>Tax and Gratuity SETTINGS</div>
            </div>
          </div>
          <div className={`${styles['form-group']} row`}>
            <div className='col-lg-9 col-md-9 col-sm-6'>
              Enable Tax
            </div>
            <div className='col-lg-3 col-md-3 col-sm-6'>
              <span className={styles['switchbox']}>
                <Field
                  component={SwitchField}
                  name='tax'
                  type='checkbox'
                />
              </span>
            </div>
          </div>
          <div className={`${styles['form-group']} row`}>
            <div className='col-lg-9 col-md-9 col-sm-6'>
              Enable Gratuity
            </div>
            <div className='col-lg-3 col-md-3 col-sm-6'>
              <span className={styles['switchbox']}>
                <Field
                  component={SwitchField}
                  name='gratuity'
                  type='checkbox'
                />
              </span>
            </div>
          </div>
          <div className={`${styles['form-group']} row`}>
            <div className='col-sm-12'>
              <div className='col-sm-12 no-padding'>
                <Field component='select' name='includeGratuityTax' className='form-control'>
                  <option value='false'>Add Tax and Gratuity to Item Price</option>
                  <option value='true'>Include Tax and Gratuity to Item Price</option>
                </Field>
              </div>
            </div>
          </div>
          <hr />
          <div className='row'>
            <div className='col-sm-12'>
              <div className={styles.header}>Other Settings</div>
            </div>
          </div>
          <div className={`${styles['form-group']} row`}>
            <div className='col-lg-9 col-md-9 col-sm-6'>
              Track Server
            </div>
            <div className='col-lg-3 col-md-3 col-sm-6'>
              <span className={styles['switchbox']}>
                <Field
                  component={SwitchField}
                  name='trackServer'
                  type='checkbox'
                />
              </span>
            </div>
          </div>
          <hr />
          <div className={`${styles['form-group']} row`}>
            <div className='col-sm-12'>
              <span className='pull-right'>
                <button type='submit' className='btn btn-primary'>Save</button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>)
  }
}

CheckoutForm.propTypes = {
  // onSubmit(values)
  onSubmit: React.PropTypes.func
}

let mapForm = {
  form: CheckoutForm.FORM_NAME
}

export default reduxForm(mapForm)(CheckoutForm)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Checkout/CheckoutForm/CheckoutForm.js